var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoThumbnailLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.08 0.08C33.36 0.08 66.64 0.08 99.92 0.08C99.92 33.36 99.92 66.64 99.92 99.92C66.64 99.92 33.36 99.92 0.08 99.92C0.08 66.64 0.08 33.36 0.08 0.08ZM61.83 62.28C62.81 60.63 58.37 57.37 57.08 56.08C52.58 51.58 48.08 47.08 43.58 42.58C42.21 41.21 40.07 38.09 38.17 37.71C37.24 39.33 40.28 40.88 40.93 42.5C39.14 44.19 35.51 47.12 35.45 49.84C35.36 54.97 44.29 59.99 48.51 60.59C51.84 61.07 55.06 58.63 57.5 58.93C59.3 59.15 60.02 61.95 61.83 62.28ZM61.5 54.83C62.67 53.76 64.51 51.9 64.55 50.16C64.63 45.96 57.88 40.9 54.33 40.08C52.29 39.61 48.22 38.11 47.01 40.5C51.84 45.28 56.67 50.06 61.5 54.83ZM46.5 48.19C48.28 49.98 50.06 51.77 51.83 53.56C48.49 55.17 44.65 51.58 46.5 48.19Z",
    fill: "#a0a0a0ff",
    fillRule: "evenodd",
    stroke: "#a0a0a0ff",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.83 62.28C60.02 61.95 59.3 59.15 57.5 58.93C55.06 58.63 51.84 61.07 48.51 60.59C44.29 59.99 35.36 54.97 35.45 49.84C35.51 47.12 39.14 44.19 40.93 42.5C40.28 40.88 37.24 39.33 38.17 37.71C40.07 38.09 42.21 41.21 43.58 42.58C48.08 47.08 52.58 51.58 57.08 56.08C58.37 57.37 62.81 60.63 61.83 62.28ZM61.5 54.83C56.67 50.06 51.84 45.28 47.01 40.5C48.22 38.11 52.29 39.61 54.33 40.08C57.88 40.9 64.63 45.96 64.55 50.16C64.51 51.9 62.67 53.76 61.5 54.83ZM46.5 48.19C44.65 51.58 48.49 55.17 51.83 53.56C50.06 51.77 48.28 49.98 46.5 48.19Z",
    fill: "white",
    fillRule: "evenodd",
    stroke: "white",
    strokeWidth: 0.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoThumbnailLight);
export default __webpack_public_path__ + "static/media/no-thumbnail-light.18a38034343eb4e16c867ae8427dd855.svg";
export { ForwardRef as ReactComponent };